import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const onboardingState = (state: RootState) => state.onboarding;

export const getGuidesStatus = createSelector(onboardingState, ({ guidesStatus }) => guidesStatus);
